import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import DateMoveField from './dateMoveComponentPage';
import { onDateChange } from '../../infrastructure/address';
class DateMoveComponent extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { type, formValues, onDateChange, currentIndex, dateIndex } = this.props;
    return (
      <DateMoveField
        type={type}
        formValues={formValues}
        currentIndex={currentIndex}
        dateIndex={dateIndex}
        onDateChange={onDateChange}
      />
    );
  }
}

DateMoveComponent.propTypes = {
  type: PropTypes.string,
  dateIndex: PropTypes.string,
  onDateChange: PropTypes.func.isRequired
};

const actionCreators = {
  onDateChange
};

const mapDispatchToProps = dispatch => bindActionCreators(actionCreators, dispatch);
export default connect(null, mapDispatchToProps)(DateMoveComponent);
